/* eslint-disable vars-on-top */
/* eslint-disable id-length */
/* eslint-disable consistent-return */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
$(document).ready(function() { // NOSONAR
  if ($('#ph-dashboard-graph').length > 0) {
    var barThick = 30,
        currentyrText = $('.ph-graph-text-currentyr').val(),
        lastyrText = $('.ph-graph-text-lastyr').val(),
        currentmonthText = $('.ph-graph-text-currentmonth').val(),
        dateObj = new Date(),
        monthNames = [];

    if ($(window).width() < 600) {
      barThick = 9;
    }

    var curentyearColor = '#1d4c84',
        cMcolor = '#f2c544',
        previousYearColor = 'lightblue',
        dashboardBarChartData = {
          labels: monthNames,
          datasets: [
            {
              label: currentyrText,
              backgroundColor: [
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor,
                curentyearColor
              ],
              barThickness: barThick,
              borderWidth: 1,
              borderRadius: 5,
              data: []
            },
            {
              label: lastyrText,
              backgroundColor: previousYearColor,
              borderWidth: 1,
              barThickness: barThick,
              borderRadius: 5,
              data: []
            },
            {
              label: currentmonthText + '          ',
              backgroundColor: cMcolor,
              borderColor: cMcolor
            }
          ]
        };


    var chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'top',
        align: 'end',
        textAlign: 'left',
        labels: {
          usePointStyle: true
        },
        onClick: function(e) {
          return e.stopPropagation();
        }
      },
      title: {
        display: false,
        text: 'MultiBar Chart'
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              labelString: 'probability'
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: false
            }

          }
        ]
      },
      tooltips: {
        backgroundColor: '#ffffff',
        titleFontColor: curentyearColor,
        bodyFontColor: '#666666',
        borderColor: '#cccccc',
        borderWidth: 1,
        displayColors: false,
        mode: 'single',
        callbacks: {
          label: function(tooltipItems) { // NOSONAR
            var decimaltooltipvalue = parseFloat(tooltipItems.value),
                currentMonth = monthNames[dateObj.getMonth()];

            decimaltooltipvalue = Math.round(decimaltooltipvalue * 100) / 100;

            if (tooltipItems.xLabel === currentMonth && tooltipItems.datasetIndex === 0) {
              tooltipItems.xLabel = currentmonthText + ' :' + decimaltooltipvalue;

              return tooltipItems.xLabel;
            }

            if (tooltipItems.datasetIndex === 0) {
              tooltipItems.xLabel = currentyrText + ':' + decimaltooltipvalue;

              return tooltipItems.xLabel;
            }

            if (tooltipItems.datasetIndex === 1) {
              tooltipItems.xLabel = lastyrText + ':' + decimaltooltipvalue;

              return tooltipItems.xLabel;
            }
          }
        }

      }

    };

    $.ajax({
      url: ACC.config.encodedContextPath + '/dashboard/salesData',
      type: 'GET',
      datatype: 'json',
      success: function(salesData) {
        for (var count = 0; count < salesData.currentYear.length; count = count + 1) {
          dashboardBarChartData.datasets[0].data.push(salesData.currentYear[count].oitAmount);
          dashboardBarChartData.datasets[1].data.push(salesData.lastYear[count].oitAmount);
          monthNames.push(salesData.lastYear[count].oitMonth);
        }

        var cYarr = dashboardBarChartData.datasets[0],
            ylbl = salesData.currentYear[0].oitCurrency,
            ctx = document.getElementById('canvas').getContext('2d'),
            plugindata = [];

        cYarr.backgroundColor[dateObj.getMonth()] = cYarr.backgroundColor[dateObj.getMonth()].replace(curentyearColor, cMcolor);
        chartOptions.scales.yAxes[0].scaleLabel.labelString = ylbl;

        if ($(window).width() > 600) {
          ctx.canvas.width = 500;
          ctx.canvas.height = 450;

          var offset = 25;

          plugindata = [
            {
              afterUpdate: function(chart) {
                ACC.availabilityinfo.afterUpdateDesk(chart, offset);
              }
            }
          ];
        } else {
          ctx.canvas.width = 350;
          ctx.canvas.height = 350;

          var offsetMob = 7;

          plugindata = [
            {
              afterUpdate: function(chart) {
                ACC.availabilityinfo.afterUpdateMob(chart, offsetMob);
              }
            }
          ];
        }

        /* eslint-disable no-undef*/
        Chart.plugins.register({ // NOSONAR
          beforeDraw: function(c) {
            var legends = c.legend.legendItems;

            legends.forEach(function(e, i) {
              if (i === 0) {
                e.fillStyle = '#1d4c84';
              }
            });
          }
        });
        /* eslint-enable no-undef*/
        window.myBar = new window.Chart(ctx, {
          type: 'bar',
          plugins: plugindata,
          data: dashboardBarChartData,
          options: chartOptions
        });
        $('.ph-salesgraph_panel').removeClass('hidden');
      }
    });
  }
});
/* eslint-enable vars-on-top */
/* eslint-enable id-length */
/* eslint-enable consistent-return */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
